import axios from "axios";
import { makeRequest } from "../../../utils/helpers/helperMethods/makeRequest";
import { GetUsersParams } from "../../users/types";

export async function getSingleClient(url: string, accessToken: string) {
  try {
    const response = await (await makeRequest(accessToken, url, 'GET', null, ''));
    if (response.ok) {
      return response.json();
    } else {
      throw new Error("Job get Failed");
    }
  } catch (e) {
    throw new Error("Job get Failed");
  }
}

export async function DeleteClient(id: string, accessToken: any, url: string) {
  try {
    const response = await (await makeRequest(accessToken, url, 'DELETE', id, ''));
    if (response.ok) {
      return { message: 'Lead Deleted', success: true };
    } else {
      throw new Error("Lead delete failed");
    }
  } catch (e) {
    throw "Lead delete failed"
  }
}


export async function getUsersCustomers({
  PageNumber,
  SearchText,
  SortOrder,
  PageSize,
  OrderBy,
  ParameterOne,
  ParameterTwo,
  ParameterThree,
  url,
  accessToken
}: GetUsersParams) {
  try {
    let endpoint = `${url}/users?PageSize=${PageSize}&PageNumber=${PageNumber}&SearchText=${SearchText}&OrderBy=${OrderBy}&SortOrder=${SortOrder}&ParameterOne=${ParameterOne}&ParameterTwo=${ParameterTwo}`;
    const response = await (await makeRequest(accessToken, endpoint, 'GET', null, ''));
    if (response.ok) {
      return response.json();
    } else {
      throw new Error("Users get Failed");
    }
  } catch (e) {
    throw new Error("Users get Failed");
  }
}

export async function getAllCustomers(url: string, accessToken: string) {
  try {
    let endpoint = `${url}/users/customers`
    const response = await (await makeRequest(accessToken, endpoint, 'GET', null, ''));
    if (response.ok) {
      return response.json();
    } else {
      throw new Error("Customers get Failed");
    }
  } catch (e) {
    throw new Error("Customers get Failed");
  }
}